const shadows = {
  low: '0px 0px 5px rgba(51, 61, 108, 0.16)',
  medium: '0px 3px 9px rgba(51, 61, 108, 0.24)',
  high: '0px 10px 30px rgba(51, 61, 108, 0.48)',
} as const;

export default shadows;
